let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kfXhT"), load("2Lfdl"), load("jKdTq")]).then(() => parcelRequire('jSKfU'));